import React from "react";

export default class NearbyServices extends React.Component  
{
    constructor(props)    
    {
        super(props);

        const code = this.props.code;
        const codes = this.props.codes;
        const place = this.props.place.state !== undefined ? this.props.place.state.name : '';        
        this.place = place;
        this.services = this.props.services.length > 0 ? this.props.services : [];    
       
        this.codename = 'Dumpster Rental';

        codes.map(c =>
        {
            if(c.code === code) this.codename = c.name;
            return true;
        });

        this.ulclass = code !== undefined ? code : '';        
    }
    
    render()
    {
        return (
            <div className="popular-services">
                <h2>Nearby Places for {this.codename}</h2>
                <article className="provider-card">
                    <ul className={"items-list "+this.ulclass}>
                        {
                            this.services.map((service, index) =>
                            {                                
                                let servicename = service.n !== null ? service.n.split(',')[0] : '';     
                                let serviceurl = service.url !== null ? service.url : '#';
                                
                                return(
                                    <a key={index} href={'/'+serviceurl} className="item">
                                        <div className="item-text">                                    
                                            <h6>{`${servicename} ${this.codename}`}</h6>
                                        </div>
                                    </a>  
                                )
                            })
                        }                   
                        </ul>
                </article>
            </div>)
    }
};